import { Component, OnInit } from '@angular/core';

import { UniLayoutFacade } from '../../../uni-layout';

@Component({
  selector: 'uni-page-403',
  templateUrl: './uni-page-403.component.html'
})
export class UniPage403Component implements OnInit {
  constructor(private uniLayoutFacade: UniLayoutFacade) {}

  ngOnInit() {
    this.uniLayoutFacade.setIsLoader(false);
  }
}
